import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from "firebase/storage";

import { doc, updateDoc } from "firebase/firestore";
import app, { db } from "../firebase";

const storage = getStorage(app);

export async function uploadProjectFileToStorage({
  projectId,
  file,
  category,
  userEmail
}) {
  const filePath = `projectFiles/${projectId}/${Date.now()}_${file.name}`;
  const fileRef = ref(storage, filePath);

  await uploadBytes(fileRef, file);

  const downloadURL = await getDownloadURL(fileRef);

    return {
    name: file.name,
    url: downloadURL,
    path: filePath,
    category: category || "Genel",
    size: file.size,
    type: file.type,
    uploadedAt: new Date().toISOString(),
    uploadedBy: userEmail || ""
    };
}

export async function updateProjectFiles(projectId, files) {
  await updateDoc(doc(db, "projects", projectId), {
    files
  });
}

export async function deleteProjectFileFromStorage(filePath) {
  const fileRef = ref(storage, filePath);
  await deleteObject(fileRef);
}